export enum SurveyActivity {
  CLICKED = 'clicked',
  CREATED = 'created',
  FEEDBACK = 'feedback',
  OPENED = 'opened',
  SENT = 'sent',
}
